import React from 'react';
import { Fade } from 'react-awesome-reveal';

import { Paragraph } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField, Container } from '../../../components';
import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_TABLET } from '../../../config/constants';

import './style.scss';

const NodeKPLandingPage = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], '');
  const heroImageMobile = entity.getIn(['field_image', 0, 'styles', 'homepage_hero_mobile'], null);
  const heroImageTablet = entity.getIn(['field_image', 0, 'styles', 'hero_tablet'], null);
  const heroImageDesktop = entity.getIn(['field_image', 0, 'styles', 'hero_desktop'], null);

  return (
    <div className="NodeKPLandingPage">
      <div className="NodeKPLandingPage__hero">
        <Image
          className="NodeKPLandingPage__hero__image"
          lazyload={false}
          src={{
            [SCREEN_MOBILE]: heroImageMobile,
            [SCREEN_TABLET]: heroImageTablet,
            [SCREEN_NORMAL]: heroImageDesktop,
          }}
          includeWebP
        />

        <div className="NodeKPLandingPage__hero__content__wrapper">
          <Container>
            <Fade triggerOnce bottom distance="50px" duration={500}>
              <div className="NodeKPLandingPage__hero__content">
                <h1 className="NodeKPLandingPage__hero__content__title">{title}</h1>
                {body && (
                  <WysiwygField
                    property="schema:text"
                    className="NodeKPLandingPage__hero__content__body"
                    html={entity.getIn(['body', 0, 'value'], '')}
                  />
                )}
              </div>
            </Fade>
          </Container>
        </div>
      </div>

      {entity.getIn(['field_paragraphs']).size > 0 && (
        <div className="Paragraphs">
          {
            entity.getIn(['field_paragraphs']).map((item, index) => {
              const paragraphId = item.get('target_id');
              const paragraph = item.getIn(['entity']);
              return (
                <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} containerless />
              );
            })
          }
        </div>
      )}
    </div>
  );
};

export default NodeKPLandingPage;
